<template>
  <div class="checklist">
    <div class="checklist__body">
      <p>
        Проект не готов к расчету.<br />
        Чтобы выполнить расчет необходимо:
      </p>
      <div class="list">
        <div class="list__item">
          1. Загрузить подложку
          <div class="success-badge" v-if="!errors.substrate">Сделано</div>
          <div v-else class="error-badge">Ожидается</div>
        </div>
        <div class="line" />
        <div class="list__item">
          2. Задать масштаб
          <div class="success-badge" v-if="!errors.size">Сделано</div>
          <div v-else class="error-badge">Ожидается</div>
        </div>
        <div class="line" />
        <div class="list__item">
          3. Создать хотя бы одну технологическую установку<br />
          или трубопровод
          <div class="success-badge" v-if="!errors.count">Сделано</div>
          <div v-else class="error-badge">Ожидается</div>
        </div>
        <div class="line" />
        <div class="list__item">
          4. Разместить хотя бы одну технологическую установку<br />
          или трубопровод на подложке
          <div class="success-badge" v-if="!errors.onMap">Сделано</div>
          <div v-else class="error-badge">Ожидается</div>
        </div>
      </div>
    </div>
    <div class="checklist__footer">
      <main-button @click="$emit('onCancelClick')">Закрыть</main-button>
    </div>
  </div>
</template>

<script>
import MainButton from "../../components/ui/MainButton.vue";

export default {
  components: { MainButton },
  props: {
    errors: {
      type: Object,
    },
  },
  data() {
    return {
      approval: false,
    };
  },
};
</script>

<style>
.checklist {
  font-family: "Inter", sans-serif;
}
.checklist__footer {
  background-color: var(--background-color);
  padding: 16px 24px;
}
.checklist__body {
  padding: 0 24px 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.checklist__body p {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black-color);
}
.list {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.list__item {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black-color);
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.success-badge {
  background-color: var(--green-1-color);
  padding: 2px 6px;
  border: 1px solid var(--green-5-color);
  color: var(--green-5-color);
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  width: fit-content;
  border-radius: 24px;
}
.error-badge {
  background-color: var(--red-1-color);
  padding: 2px 6px;
  border: 1px solid var(--red-5-color);
  color: var(--red-5-color);
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  width: fit-content;
  border-radius: 24px;
}
.line {
  width: 100%;
  height: 0;
  border: 0.5px solid var(--border-color);
}
</style>
